module.exports = __webpack_public_path__ + "img/1432313971.4d7cbd4b.jpg";